import React, { useEffect, useState } from "react";
import "./styles/index.less";
import {
  Button,
  Col,
  Input,
  Modal,
  Row,
  Table,
  Form,
  Radio,
  RadioChangeEvent,
  Switch,
  Tooltip,
  Typography,
  Layout,
  message,
  Spin,
  Breadcrumb,
} from "antd";
import dayjs from "dayjs";
import "dayjs/locale/th";
import buddhistEra from "dayjs/plugin/buddhistEra";
import {
  DeleteOutlined,
  EditOutlined,
  ExclamationCircleFilled,
  ExportOutlined,
  EyeInvisibleOutlined,
  EyeTwoTone,
  PlusOutlined,
} from "@ant-design/icons";
import {
  get_all_org_user,
  get_all_user,
  get_role,
  get_user,
  save_user_status,
  admin_user_create,
  user_delete,
  user_update,
  export_user,
} from "../../services/user";
import Search from "antd/es/input/Search";
import { get_all_org } from "../../services/org";
import userall from "../../assets/iconshare/avatar.png";
import { useAuth } from "../../utils/Auth/AuthWrapper";
import { useTranslation } from "react-i18next";

dayjs.extend(buddhistEra);

const { confirm } = Modal;
const { Title } = Typography;
const { Content } = Layout;

type Props = {};

const User = (props: Props) => {
  const [form] = Form.useForm();
  const auth = useAuth();
  const [userData, setUserData]: any = useState([]);
  const [orgData, setOrgData]: any = useState([]);
  const [isModalOpen, setIsModalOpen] = useState<any>(false);
  const [isCreate, setIsCreate] = useState<any>(true);
  const [role, setRole] = useState(1);
  const [loading, setLoading] = useState(true);
  const [userPermission, setUserPermission]: any = useState([]);

  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const { t } = useTranslation();

  // table
  const columns: any = [
    {
      title: "#",
      dataIndex: "id",
      width: 80,
      key: "id",
      render: (text: any, record: any, index: any) => index + 1,
    },
    {
      title: (
        <div style={{ fontSize: "19px", textAlign: "center" }}>
          {t("Name user")}
        </div>
      ),
      width: 250,
      dataIndex: "name",
      key: "name",
      sorter: (a: any, b: any) => a.name.localeCompare(b.name),
      render: (_: any, record: any) => {
        return (
          <Tooltip title={record.name}>
            <Row align="middle" gutter={16}>
              <Col>
                <img
                  src={
                    record.profile_img === null ? userall : record.profile_img
                  }
                  style={{ width: "30px", height: "30px", borderRadius: "50%" }}
                />
              </Col>
              <Col style={{ width: "150px" }}>
                <span className="table-displayname">{record.name}</span>
              </Col>
            </Row>
          </Tooltip>
        );
      },
    },
    {
      title: (
        <div style={{ fontSize: "18px", textAlign: "center" }}>
          {t("Username")}
        </div>
      ),
      width: 170,
      key: "username",
      render: (_: any, record: any) => record.username,
    },
    {
      title: (
        <div style={{ fontSize: "18px", textAlign: "center" }}>
          {t("Email")}
        </div>
      ),
      width: 280,
      key: "email",
      render: (_: any, record: any) => record.email,
    },
    {
      title: (
        <div style={{ fontSize: "18px", textAlign: "center" }}>{t("Role")}</div>
      ),
      key: "role",
      width: 150,
      dataIndex: "role_name",
      sorter: (a: any, b: any) => {
        const rolePriority: Record<string, number> = {
          Administrator: 1,
          "Super Admin": 2,
          Member: 3,
        };

        return (
          (rolePriority[a.role_name] || 99) - (rolePriority[b.role_name] || 99)
        );
      },
      render: (_: any, record: any) => record.role_name,
    },
    {
      title: (
        <div style={{ fontSize: "18px", textAlign: "center" }}>
          {t("created at")}
        </div>
      ),
      width: 200,
      key: "create_at",
      dataIndex: "create_at", // เพิ่มเพื่อให้ table รู้จัก field
      sorter: (a: any, b: any) =>
        dayjs(a.create_at).unix() - dayjs(b.create_at).unix(),
      render: (_: any, record: any) => {
        console.log("record date ::", record);
        return (
          <div>
            {dayjs(record.create_at).locale("th").format("D MMMM BBBB")}
          </div>
        );
      },
    },
    {
      title: (
        <div style={{ fontSize: "18px", textAlign: "center" }}>
          {t("last login")}
        </div>
      ),
      width: 200,
      key: "last_login",
      dataIndex: "lasted_login", // เพิ่มเพื่อให้ table รู้จัก field
      sorter: (a: any, b: any) =>
        dayjs(a.lasted_login).unix() - dayjs(b.lasted_login).unix(),
      render: (_: any, record: any) => {
        return (
          <div>
            {dayjs(record.lasted_login).locale("th").format("D MMMM BBBB")}
          </div>
        );
      },
    },
    {
      title: (
        <div style={{ fontSize: "18px", textAlign: "center" }}>
          {t("Active")}
        </div>
      ),
      width: 100,
      sorter: false,
      dataIndex: "updatedAt",
      valueType: "dateTime",
      align: "center",
      render: (_: any, record: any) => {
        const isCurrentUser = record.user_id === auth.user.user_id;
        if (record.status == 1) {
          return (
            <Switch
              disabled={isCurrentUser}
              onChange={async (checked: any) => {
                if (isCurrentUser) return;
                if (checked) {
                  const res = await save_user_status({
                    data: {
                      status: 1,
                      user_id: record.user_id,
                    },
                  });
                } else {
                  const res = await save_user_status({
                    data: {
                      status: 2,
                      user_id: record.user_id,
                    },
                  });
                }
              }}
              defaultChecked
            />
          );
        }
        return (
          <Switch
            disabled={isCurrentUser}
            onChange={async (checked: any) => {
              if (isCurrentUser) return;
              if (checked) {
                const res = await save_user_status({
                  data: {
                    status: 1,
                    user_id: record.user_id,
                  },
                });
              } else {
                const res = await save_user_status({
                  data: {
                    status: 2,
                    user_id: record.user_id,
                  },
                });
              }
            }}
          />
        );
      },
    },
    {
      title: <div style={{ fontSize: "18px", textAlign: "center" }}></div>,
      dataIndex: "",
      align: "center",
      key: "tags",
      width: 150,
      render: (_: any, record: any) => (
        <Row gutter={16} justify={"center"}>
          <Tooltip placement="bottom" title="Edit">
            <Col
              style={{ color: "#989898", cursor: "pointer" }}
              onClick={() => {
                getFocusUser(record);
                setIsCreate(false);
                setIsModalOpen(true);
                // }
              }}
            >
              <Button
                style={{ backgroundColor: "#fcf2cf" }}
                icon={<EditOutlined style={{ color: "#f3c62b" }} />}
              />
            </Col>
          </Tooltip>
          <Tooltip placement="bottom" title="Delete">
            <Col
              style={{ color: "#989898", cursor: "pointer" }}
              onClick={() => {
                if (
                  record.role_id == "99999999-0000-0000-0000-999999999999" &&
                  record.user_id == auth.user.user_id
                ) {
                  Modal.error({
                    title: t("Permission Denined"),
                    content: t("Deleting your own data is not allowed"),
                  });
                } else {
                  showDeleteConfirm(record.user_id, record.name);
                }
              }}
            >
              <Button
                style={{ backgroundColor: "#FFDFDF" }}
                icon={<DeleteOutlined style={{ color: "#B31312" }} />}
              />
            </Col>
          </Tooltip>
        </Row>
      ),
    },
  ];

  // fatch data
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await getOrgData();
      await getData();
      setLoading(false);
    };

    fetchData();
  }, []);

  // get org
  const getOrgData = async () => {
    try {
      const res = await get_all_org();
      setOrgData(res.result);
    } catch (e) {
      console.error(e);
    }
  };

  // get add id
  const getData = async () => {
    try {
      const role = await get_role();
      let res;
      if (role.result[0].role_name !== "Super Admin") {
        res = await get_all_org_user({ org_id: role.result[0].org_id });
      } else {
        res = await get_all_user();
      }
      setUserData(res.result);
      setUserPermission(role.result[0]);
    } catch (e) {
      console.error(e);
    }
  };

  // set field on form
  const getFocusUser = async (record: any) => {
    let roleValue = 2;
    if (record.role_id === "a8717515-be10-4e72-8d6d-da622284c2f4") {
      roleValue = 1;
    } else if (record.role_id === "99999999-0000-0000-0000-999999999999") {
      roleValue = 3;
    }

    form.setFieldsValue({
      id: record.user_id,
      role: roleValue,
      org: record.org,
      name: record.name,
      username: record.username,
      user_code: record.user_code,
      email: record.email,
      password: record.password,
    });
  };

  // delete user
  const showDeleteConfirm = (id: string, name: string) => {
    confirm({
      title: t("delete title"),
      icon: <ExclamationCircleFilled style={{ color: "#FF3B30" }} />,
      content: (
        <div className="custom-modal-content-news">
          <p>
            {t("alert title user")}&nbsp;<strong>{name}</strong>&nbsp;
            {t("yes or no")}
          </p>
        </div>
      ),
      okText: t("yes"),
      okType: "danger",
      cancelText: t("no"),
      onOk: async () => {
        try {
          const res = await user_delete({ data: { user_id: id } });
          message.success("Delete Success!");
          getData();
        } catch (e) {
          console.error(e);
        }
      },
      onCancel() {},
    });
  };

  // create user
  const handleCreateUser = async (value: any) => {
    try {
      let role_id = "";
      if (userPermission.role_name !== "Super Admin") {
        form.setFieldsValue({
          org: userPermission.org_id,
        });
      }
      if (form.getFieldValue("role") == 1) {
        role_id = "a8717515-be10-4e72-8d6d-da622284c2f4"; // Admin
      } else if (form.getFieldValue("role") == 2) {
        role_id = "ecbf4355-952b-4cc2-8136-8353ca55b0d2"; // Member
      } else if (form.getFieldValue("role") == 3) {
        role_id = "99999999-0000-0000-0000-999999999999"; // Super Admin
      }
      const res = await admin_user_create({
        data: {
          name: form.getFieldValue("name").trim(),
          username: form.getFieldValue("username").trim(),
          email: form.getFieldValue("email").trim(),
          password: form.getFieldValue("password"),
          org_id: "e82fb7f3-3fa0-446d-8ef4-9743421b4ca8",
          role_id: role_id,
          org: form.getFieldValue("org"),
        },
      });

      if (res.status === 1 || res.message === "success") {
        message.success("เพิ่มผู้ใช้สำเร็จ");
        getData();
        form.resetFields();
        setIsModalOpen(false);
      } else {
        message.error(res.message || "เกิดข้อผิดพลาด");
      }
    } catch (e) {
      console.error(e);
      message.error("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
    }
  };

  // update data
  const handleUpdateUser = async (value: any) => {
    try {
      if (userPermission.role_name !== "Super Admin") {
        message.error("คุณไม่มีสิทธิ์ในการแก้ไขข้อมูลผู้ใช้อื่น");
        return;
      }
      let role_id = "";
      if (form.getFieldValue("role") == 1) {
        role_id = "a8717515-be10-4e72-8d6d-da622284c2f4"; // Admin
      } else if (form.getFieldValue("role") == 2) {
        role_id = "ecbf4355-952b-4cc2-8136-8353ca55b0d2"; // Member
      } else if (form.getFieldValue("role") == 3) {
        role_id = "99999999-0000-0000-0000-999999999999"; // Super Admin
      }
      const res = await user_update({
        data: {
          user_id: form.getFieldValue("id"),
          name: form.getFieldValue("name").trim(),
          username: form.getFieldValue("username").trim(),
          email: form.getFieldValue("email").trim(),
          role_id: role_id,
          org: form.getFieldValue("org"),
        },
      });
      if (res.status === 1 || res.message === "success") {
        message.success("แก้ไขข้อมูลผู้ใช้สำเร็จ");
        getData();
        form.resetFields();
        setIsModalOpen(false);
      } else {
        message.error(res.message || "เกิดข้อผิดพลาด");
      }
    } catch (e) {
      console.error(e);
      message.error("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
    }
  };

  // search
  useEffect(() => {
    const lowerSearch = searchText.toLowerCase();
    const filtered = userData.filter((user: any) => {
      return (
        user.name?.toLowerCase().includes(lowerSearch) ||
        user.username?.toLowerCase().includes(lowerSearch) ||
        user.email?.toLowerCase().includes(lowerSearch)
      );
    });
    setFilteredData(filtered);
  }, [searchText, userData]);

  const onSearch = (value: any) => {
    setSearchText(value);
  };

  return (
    <Layout>
      <Content className="user-layout">
        {/* head step */}
        <div>
          <Row justify="space-between" align="middle">
            <Breadcrumb
              separator=">"
              items={[
                {
                  title: (
                    <span style={{ fontWeight: "bold" }}>{t("User")}</span>
                  ),
                },
              ]}
            />
            <Col>
              <Search
                placeholder="Search"
                onChange={(e) => onSearch(e.target.value)}
                onSearch={onSearch}
                style={{ width: 300, marginRight: "10px" }}
              />
              <Button
                style={{ backgroundColor: "#00215E", color: "white" }}
                type="primary"
                key="primary"
                onClick={() => {
                  form.resetFields();
                  setIsCreate(true);
                  setIsModalOpen(true);
                }}
              >
                <PlusOutlined />
                {t("Add User")}
              </Button>
              <Button
                style={{
                  backgroundColor: "#00215E",
                  color: "white",
                  marginLeft: "10px",
                }}
                type="primary"
                key="primary"
                onClick={async () => {
                  try {
                    const blob = await export_user({
                      format: "xlsx",
                      filename: "user_export_excel",
                    });
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = `user_${dayjs().format("YYYYMMDD_HHmmss")}.xlsx`;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);
                    message.success("Export สำเร็จ");
                  } catch (e) {
                    console.error(e);
                    message.error("Export ไม่สำเร็จ");
                  }
                }}
              >
                <ExportOutlined />
                {t("Export User")}
              </Button>
            </Col>
          </Row>
          <hr />
        </div>

        {/* spin and table */}
        <div className="table-user">
          {loading ? (
            <Row justify="center" align="middle" style={{ height: "50vh" }}>
              <Spin size="large" />
            </Row>
          ) : (
            <Table
              rowClassName="UserTable"
              className="custom-table-task"
              rowKey="user_id"
              columns={columns}
              dataSource={filteredData}
              pagination={{
                showTotal: (total, range) =>
                  `แสดงรายการต่อหน้า : ${range[0]}-${range[1]} จาก ${total} รายการ`,
                defaultPageSize: 10,
                showSizeChanger: true,
                pageSizeOptions: ["10", "25", "50", "100"],
              }}
              scroll={{ x: "max-content" }}
            />
          )}

          {/* modal form */}
          <Modal
            title={isCreate ? t("Add User") : t("Edit user data")}
            open={isModalOpen}
            onOk={() => form.submit()}
            onCancel={() => setIsModalOpen(false)}
            width={600}
          >
            <div>
              <Form
                labelCol={{ flex: "110px" }}
                labelAlign="left"
                labelWrap
                wrapperCol={{ flex: 1 }}
                form={form}
                onFinish={isCreate ? handleCreateUser : handleUpdateUser}
              >
                <div style={{ marginBottom: "3%", marginTop: "3%" }}>
                  <Form.Item name="id" style={{ display: "none" }}>
                    <Input placeholder="Email" />
                  </Form.Item>

                  <Form.Item
                    name="role"
                    label={t("Role")}
                    rules={[
                      { required: true, message: "Please select your role!" },
                    ]}
                  >
                    <Radio.Group
                      disabled={form.getFieldValue("id") === auth.user.user_id}
                    >
                      <Radio value={1}>{t("admin")}</Radio>
                      <Radio value={2}>{t("member")}</Radio>
                      <Radio value={3}>{t("superadmin")}</Radio>
                    </Radio.Group>
                  </Form.Item>

                  <Form.Item
                    name="name"
                    label={t("Name user")}
                    rules={[
                      { required: true, message: "Please input your name!" },
                    ]}
                  >
                    <Input
                      placeholder={t("Name user")}
                      autoComplete="new-name"
                    />
                  </Form.Item>

                  <Form.Item
                    name="user_code"
                    label={t("Usercode")}
                    rules={[
                      {
                        required: false,
                        message: "Please input your usercode!",
                      },
                    ]}
                  >
                    <Input autoComplete="new-user_code" disabled />
                  </Form.Item>

                  <Form.Item
                    name="org"
                    label={t("organization")}
                    rules={[
                      {
                        required: true,
                        message: "Please input your organization!",
                      },
                    ]}
                  >
                    <Input
                      placeholder={t("organization")}
                      autoComplete="new-org"
                    />
                  </Form.Item>

                  <Form.Item
                    name="username"
                    label={t("Username")}
                    rules={[
                      {
                        required: true,
                        message: "Please input your username!",
                      },
                    ]}
                  >
                    <Input
                      placeholder={t("Username")}
                      autoComplete="new-name-display"
                      disabled={!isCreate}
                    />
                  </Form.Item>

                  <Form.Item
                    name="email"
                    label={t("Email")}
                    rules={[
                      { required: true, message: "Please input your email!" },
                    ]}
                  >
                    <Input
                      placeholder={t("Email")}
                      autoComplete="new-email"
                      disabled={!isCreate}
                    />
                  </Form.Item>

                  <Form.Item
                    name="password"
                    label={t("password")}
                    rules={[
                      {
                        required: true,
                        message: "Please input your password!",
                      },
                    ]}
                    style={{ display: isCreate ? "" : "none" }}
                  >
                    <Input.Password
                      placeholder={t("password")}
                      autoComplete="new-password"
                      iconRender={(visible) =>
                        visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                      }
                    />
                  </Form.Item>
                </div>
              </Form>
            </div>
          </Modal>
        </div>
      </Content>
    </Layout>
  );
};

export default User;
